module.exports = "/_next/static/images/bottom-banner-shopping-67789934809677c3d9548e3c5a33a16d.jpg";